import _ from 'lodash';
/** consle log for development stage ONLY
 */
const log = (DEV_MODE) ? console.log.bind(window.console) : (() => '');
export {
    log,
};

/** parse json, if fail then return defaultValue
 * @param {string} string
 * @param {any} defaultValue
 * @returns {object} json
 */
export function jsonParse(string, defaultValue = {}) {
    let json = _.attempt(JSON.parse, string);
    if (_.isError(json)) {
        log('JSON parse fail');
        json = defaultValue;
    }
    return json;
}

/** translate second to mm:ss:ms
 * @param {string} second
 * @returns {string} mm:ss:ms
 */
export function secondToTime(second) {
    if (second > 60 * 60) return '??:??';
    const timeArray = (second + '').split('.');
    const intSecond = parseInt(timeArray[0], 10);
    const microSecoond = (timeArray.length > 1) ? parseInt(timeArray[1], 10) * 60 / (10 * timeArray[1].length) : 0;
    return `${('0'+Math.floor(intSecond/60)).slice(-2)}:${('0' + intSecond%60).slice(-2)}:${('0' + microSecoond%60).slice(-2)}`;
}

/** fullscreen browserconst
 */
export function fullScreen() {
    const doc = window.document;
    const docEl = doc.documentElement;
    const requestFullScreen = docEl.requestFullscreen || docEl.mozRequestFullScreen || docEl.webkitRequestFullScreen ||
        docEl.msRequestFullscreen;
    const cancelFullScreen = doc.exitFullscreen || doc.mozCancelFullScreen || doc.webkitExitFullscreen ||
        doc.msExitFullscreen;
    requestFullScreen.call(docEl);
}

/** move element forward inside array
 * @param {array} arr original array
 * @param {number} index moving index
 * @returns {array} result array
 */
export function arrayElementMoveForward(arr, index) {
    if (index < 0 || !Number.isInteger(index) || index >= arr.length) {
        log('[ERR] arrayElementMoveForward', 'wrong index', index);
        return arr;
    }
    const arrClone = JSON.parse(JSON.stringify(arr));
    arrClone.splice(index, 2, arrClone[index + 1], arrClone[index]);
    return arrClone;
}

/** move element backword inside array
 * @param {array} arr original array
 * @param {number} index moving index
 * @returns {array} result array
 */
export function arrayElementMoveBackword(arr, index) {
    if (index < 0 || !Number.isInteger(index) || index >= arr.length) {
        log('[ERR] arrayElementMoveBackword', 'wrong index', index);
        return arr;
    }
    const arrClone = JSON.parse(JSON.stringify(arr));
    arrClone.splice(index - 1, 2, arrClone[index], arrClone[index - 1]);
    return arrClone;
}

/** move element to array begin
 * @param {array} arr original array
 * @param {number} index moving index
 * @returns {array} result array
 */
export function arrayElementMoveBegin(arr, index) {
    if (index < 0 || !Number.isInteger(index) || index >= arr.length) {
        log('[ERR] arrayElementMoveBegin', 'wrong index', index);
        return arr;
    }
    const arrClone = JSON.parse(JSON.stringify(arr));
    let target;
    if (index === arrClone.length - 1) {
        target = arrClone.pop();
        return [target].concat(arrClone);
    } else {
        target = arrClone.splice(index, 1);
        return target.concat(arrClone);
    }
}

/** move element to array begin
 * @param {array} arr original array
 * @param {number} index moving index
 * @returns {array} result array
 */
export function arrayElementMoveEnd(arr, index) {
    if (index < 0 || !Number.isInteger(index) || index >= arr.length) {
        log('[ERR] arrayElementMoveEnd', 'wrong index', index);
        return arr;
    }
    if (index === arr.length - 1) return arr;
    const arrClone = JSON.parse(JSON.stringify(arr));
    const target = arrClone.splice(index, 1);
    return arrClone.concat(target);
}



// WEBPACK FOOTER //
// ./src/js/function.js